export let appVersion = "0.0.1";


// WEBPACK FOOTER //
// ./src/ts/version.tsx